import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import AppTrainingCaloriesBarChart from '../../../../components/charts/app-training-calories-bar-chart/AppTrainingCaloriesBarChart';
import AppTrainingLoadBarChart from '../../../../components/charts/app-training-load-bar-chart/AppTrainingLoadBarChart';
import AppTrainingsRadarChart from '../../../../components/charts/app-trainings-radar-chart/AppTrainingsRadarChart';
import AppTrainingsSkillsRadarChart from '../../../../components/charts/app-trainings-skills-radar-chart/AppTrainingsSkillsRadarChart';
import AppSelectWrapper from '../../../../components/designe/textfields/app-select-wrapper/AppSelectWrapper';
import NoResults from '../../../../components/reusable/no-results';
import StatisticsChartsSkeleton from '../shared/StatisticsChartsSkeleton';
import { useStyles } from './StatisticsOverview.styles';
import { useStatisticsOverview } from './useStatisticsOverview';

const StatisticsOverview = () => {
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const {
    selectedPeriodOption,
    periodOptions,
    periodTrainings,
    exercises,
    isLoadingTrainings,
    isFetchingTrainings,
    handlePeriodChange,
  } = useStatisticsOverview();

  const isChartsLoading = isLoadingTrainings || isFetchingTrainings;

  return (
    <Box className={classes.overviewWrapper}>
      <Box className={classes.periodSelector}>
        <AppSelectWrapper
          label={t('statistics.periodLabel')}
          fieldName="name"
          disableSearch
          disableSorting
          disableClear
          options={periodOptions}
          defaultValue={selectedPeriodOption}
          onChange={handlePeriodChange}
          mode="dark"
        />
      </Box>

      {isChartsLoading && <StatisticsChartsSkeleton variant="overview" />}

      {!isChartsLoading && (
        <>
          {periodTrainings.length === 0 ? (
            <Box className={classes.emptyState}>
              <NoResults />
            </Box>
          ) : (
            <Box className={classes.chartsWrapper}>
              <Box className={classes.chartSection}>
                <Typography variant="label-text-md" marginBottom={1}>
                  {t('statistics.loadDistribution')}
                </Typography>
                <Box className={classes.chartContainer}>
                  <AppTrainingsRadarChart
                    trainings={periodTrainings}
                    exercises={exercises}
                  />
                </Box>
              </Box>
              <Box className={classes.chartSection}>
                <Typography variant="label-text-md" marginBottom={1}>
                  {t('statistics.skillsDistribution')}
                </Typography>
                <Box className={classes.chartContainer}>
                  <AppTrainingsSkillsRadarChart
                    trainings={periodTrainings}
                    exercises={exercises}
                  />
                </Box>
              </Box>
              {periodTrainings?.find((training) => training.totalLoad > 0) && (
                <Box className={classes.chartSection}>
                  <Typography variant="label-text-md" marginBottom={1}>
                    {t('statistics.loadProgress')}
                  </Typography>
                  <Box className={classes.chartContainer}>
                    <AppTrainingLoadBarChart
                      trainings={periodTrainings}
                      height={400}
                    />
                  </Box>
                </Box>
              )}
              {periodTrainings?.find(
                (training) => training.totalCalories > 0,
              ) && (
                <Box className={classes.chartSection}>
                  <Typography variant="label-text-md" marginBottom={1}>
                    {t('statistics.caloriesProgress')}
                  </Typography>
                  <Box className={classes.chartContainer}>
                    <AppTrainingCaloriesBarChart
                      trainings={periodTrainings}
                      height={400}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default StatisticsOverview;
